// El resultado de UNA consulta al proveedor: tres filas fijas —Candado, Señal y Pendiente— más el
// encabezado que dice cuándo se preguntó y a quién. La lógica vive en `refreshResultLines`.
import { cn } from '@/lib/cn';
import { MDM_HEARTBEAT_MEANING, MDM_PROVIDER_LABEL } from '../logic';
import { observedAgoLabel, readRefreshLines, type MdmRefreshLine } from '../refreshResultLines';
import type { MdmFleetDevice, MdmRefreshReview } from '../types';
import { Metric, PanelCard, SUB_LINE } from './MdmPanelUi';

export interface MdmRefreshResultPanelProps {
    review: MdmRefreshReview;
    /** El expediente como estaba antes de preguntar: de ahí sale el «antes» de cada fila. */
    before: MdmFleetDevice;
    /** El expediente ya mergeado con lo que contestó el proveedor. */
    after: MdmFleetDevice;
    now: Date | string;
}

/** Describe lo que hay adentro sin prometer definitividad: el sondeo puede corregirlo minutos después. */
const PANEL_TITLE = 'Qué contestó el proveedor';

function RefreshLineRow({ line, device }: { line: MdmRefreshLine; device: MdmFleetDevice }) {
    return (
        <div className="min-w-0">
            <Metric
                label={line.label}
                value={line.value}
                tone={line.tone}
                wrap
                help={
                    line.label === 'Señal' ? MDM_HEARTBEAT_MEANING[device.mdmProvider] : undefined
                }
            />
            {line.before ? (
                <div className={cn(SUB_LINE, 'text-muted-foreground')}>Antes: {line.before}</div>
            ) : null}
            {line.note ? (
                <div className={cn(SUB_LINE, 'text-muted-foreground')}>{line.note}</div>
            ) : null}
        </div>
    );
}

export function MdmRefreshResultPanel({ review, before, after, now }: MdmRefreshResultPanelProps) {
    const lines = readRefreshLines(review, before, after, now);
    const provider = MDM_PROVIDER_LABEL[after.mdmProvider];
    const header = `Actualizado ${observedAgoLabel(review.observedAt, now)} · según ${provider}`;

    return (
        <PanelCard title={PANEL_TITLE} meta={header}>
            {lines.map((line) => (
                <RefreshLineRow key={line.label} line={line} device={after} />
            ))}
        </PanelCard>
    );
}
